import { ReportsState } from '../../types';

export const resetUnauthorizedReport = (state: ReportsState) => {
  state.unauthorizedReport = {};
};
